export default "__VITE_ASSET__DoJyhfA6__"